export const  TokenStore = {
	get accessToken():string | null {
		return localStorage.getItem("access-token");
	},
	set accessToken(value:string | null) {
		if (!value) {
			localStorage.removeItem("access-token");
		} else {
			localStorage.setItem("access-token", value);
		}
	},

	get refreshToken():string | null {
		return localStorage.getItem("refresh-token");
	},
	set refreshToken(value:string | null) {
		if (!value) {
			localStorage.removeItem("refresh-token");
		} else {
			localStorage.setItem("refresh-token", value);
		}
	},

	get email():string | null {
		return localStorage.getItem("email");
	},
	set email(value:string | null) {
		if (!value) {
			localStorage.removeItem("email");
		} else {
			localStorage.setItem("email", value);
		}
	},

	get userId():number | null {
		let id = localStorage.getItem("userId");
		if (!id) {
			return null;
		}
		return parseInt(id);
	},
	set userId(value:number | null) {
		if (!value) {
			localStorage.removeItem("userId");
		} else {
			localStorage.setItem("userId", `${value}`);
		}
	},

	get accessExpires():Date | null {
		let val = localStorage.getItem("access-token-expires");
		if (val) {
			return new Date(parseInt(val));
		}
		return null;
	},
	set accessExpires(value:Date | null) {
		if (!value) {
			localStorage.removeItem("access-token-expires");
		} else {
			localStorage.setItem("access-token-expires", value.getTime() + "");
		}
	},

	get refreshExpires():Date | null {
		let val = localStorage.getItem("refresh-token-expires");
		if (val) {
			return new Date(parseInt(val));
		}
		return null;
	},
	set refreshExpires(value:Date | null) {
		if (!value) {
			localStorage.removeItem("refresh-token-expires");
		} else {
			localStorage.setItem("refresh-token-expires", value.getTime() + "");
		}
	}
};
